<template>
  <button @click="exportData" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus ok-only ok-title="Cancel" @ok="close">
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportData: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/lookup-customer/client', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            companyName: item.companyName ? item.companyName : '',
            phone: item.phone ? item.phone : '',
            email: item.email ? item.email : '',
            domain: item.domain ? item.domain : '',
            registrationTime: item.createTime ? moment(item.createTime).format('DD/MM/YYYY HH:mm:ss') : '',
          };
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'client-lookup.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('companyName'), key: 'companyName', width: 15},
        {header: this.$t('phone'), key: 'phone', width: 15},
        {header: this.$t('email'), key: 'email', width: 15},
        {header: 'Domain', key: 'domain', width: 15},
        {header: this.$t('registrationTime'), key: 'registrationTime', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    },
  },
  i18n: {
    messages: {
      en: {
        phone: 'Phone number',
        notFoundSearch: 'No result found! Change your search condition and try again!',
        enterNumberNote: "Please enter customer phone number!",
        customerLookup: "Look up customers",
        enterNumber: "Enter phone number",
        registrationTime: "Registration time",
        clientList: "List of clients",
      },
      vi: {
        phone: 'Số điện thoại',
        notFoundSearch: 'Không tìm thấy kết quả nào! Hãy thay đổi điều kiện tìm kiếm và thử lại!',
        enterNumberNote: "Xin hãy nhập số điện thoại khách hàng!",
        customerLookup: "Tra cứu khách hàng",
        enterNumber: "Nhập số điện thoại",
        registrationTime: "Thời gian đăng ký",
        clientList: "Danh sách client",
      }
    }
  }
}
</script>